import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Footer from './Footer';
import { useSearchContext } from './SearchContext';

const SecondarySearch = () => {
  const [keyword, setKeyword] = useState('');
  const [startYear, setStartYear] = useState('');
  const [endYear, setEndYear] = useState('');
  const [sortBy, setSortBy] = useState('1');
  const [resultsHtml, setResultsHtml] = useState('');
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const { baseUrl, buildLink } = useSearchContext();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setKeyword(queryParams.get('keyword') || '');
    setStartYear(queryParams.get('secondary_startyear') || '');
    setEndYear(queryParams.get('secondary_endyear') || '');
    setSortBy(queryParams.get('sortby') || '1');
  }, [location]);

  const handleSearch = (e) => {
    e.preventDefault();
    setLoading(true);

    const queryParams = new URLSearchParams({
      keyword,
      secondary_startyear: startYear,
      secondary_endyear: endYear,
      sortby: sortBy,
      search: 'true',
    });

    const requestUrl = `${baseUrl}/secondarysearch.php?${queryParams.toString()}`;

    fetch(requestUrl, {
      method: 'GET',
    })
      .then((response) => response.text())
      .then((html) => {
        setResultsHtml(html);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error:', err);
        setResultsHtml('<p>Error occurred. Please try again later.</p>');
        setLoading(false);
      });
  };

  return (
    <div className="container">
      <h1 className="page-header">Search the Secondary Bibliography</h1>
      <p>Search the secondary bibliography below by author, Library of Congress headings, or title.</p>
      <p>
        <a href={buildLink('/loc')} className="btn btn-default btn-xs">
          Selected Library of Congress Subject Headings to enhance your search for scholarship on Brown
        </a>
      </p>
      <form onSubmit={handleSearch} className="form-inline">
        <div className="form-group">
          <label htmlFor="keyword">Enter search term</label>
          <input
            className="form-control"
            id="keyword"
            type="text"
            name="keyword"
            size="45"
            placeholder="title, keyword, subject, author, or editor"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />

          <label htmlFor="secondary_startyear">from</label>
          <input
            className="form-control"
            type="text"
            name="secondary_startyear"
            id="secondary_startyear"
            placeholder="year"
            size="9"
            value={startYear}
            onChange={(e) => setStartYear(e.target.value)}
          />

          <label htmlFor="secondary_endyear">to</label>
          <input
            className="form-control"
            type="text"
            name="secondary_endyear"
            id="secondary_endyear"
            placeholder="year"
            size="9"
            value={endYear}
            onChange={(e) => setEndYear(e.target.value)}
          />

          <div className="radio">
            <label htmlFor="sortby">
              <strong>Order by</strong>
              <input
                name="sortby"
                type="radio"
                id="sortby"
                value="1"
                checked={sortBy === '1'}
                onChange={() => setSortBy('1')}
              />
              Date
            </label>
          </div>
          &nbsp;&nbsp;
          <div className="radio">
            <input
              name="sortby"
              type="radio"
              id="sortby"
              value="2"
              checked={sortBy === '2'}
              onChange={() => setSortBy('2')}
            />
            Author
          </div>

          <button
            type="button"
            className="btn btn-default"
            onClick={() => {
              setKeyword('');
              setStartYear('');
              setEndYear('');
              setSortBy('1');
              setResultsHtml('');
            }}
          >
            Reset
          </button>

          <button type="submit" className="btn btn-default">
            Search
          </button>
        </div>
      </form>

      {loading && <p>Loading...</p>}
      <div dangerouslySetInnerHTML={{ __html: resultsHtml }} />
      <Footer />
    </div>
  );
};

export default SecondarySearch;
